var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.9,
    height: 21,
    viewBox: "0 0 18.9 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-date-range",
    "data-name": "Icon material-date-range",
    d: "M10.8,12.45H8.7v2.1h2.1Zm4.2,0H12.9v2.1H15Zm4.2,0H17.1v2.1h2.1ZM21.3,5.1H20.25V3h-2.1V5.1H9.75V3H7.65V5.1H6.6A2.09,2.09,0,0,0,4.511,7.2L4.5,21.9A2.1,2.1,0,0,0,6.6,24H21.3a2.106,2.106,0,0,0,2.1-2.1V7.2A2.106,2.106,0,0,0,21.3,5.1Zm0,16.8H6.6V10.35H21.3Z",
    transform: "translate(-4.5 -3)",
    fill: "#d9a45c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.949efdf2d53c6d26d7b0ab6eadeffdb9.svg";
export { ForwardRef as ReactComponent };